<template>
  <div class="container">
      <!-- <div class="col-sm-6 container">
        <b-navbar type="light" variant="info">
            SCORE  5
        </b-navbar> -->
      <!-- </div> -->

   <!-- <h3>Quiz Begins Here</h3>
   funciton test <button @click="funCall()">Test Function

   </button> -->
    <!-- <div v-if="fetchedTitle">
        <h3>{{fetchedTitle}}</h3> 
        </div><p></p>
        <hr/> -->
    <!-- working components begin -->
    <titles :staticTitle="fetchedTitle" />
   <start-button v-if="isBegin" @startQuiz="showQuiz"/>
   <quiz-question v-if="isQuiz" :question="currentQuestion.question" />
   <quiz-choices v-if="isQuiz" @submitted="submitAnswer" :questid="currentQuestion.id" :choices="currentQuestion.choices" />
    <generating v-if="isGenerate" :message="'Generating Quiz...'" :color="'primary'" />
    <generating v-if="isChecking" :message="'Grading Question...'" :color="'success'" />
    <finished-quiz v-if="isFinished" :results="quizResults" @retake="showQuiz" />
    <continue-quiz v-if="isContinue" @resume="continueQuiz" @restart="showQuiz" />
    <quiz-not-found v-if="isNoQuiz" />
    <quiz-results v-if="isCompleted" :result="quizResults" />

   <!-- working components end -->
   
   
   <!-- <div v-if="isGenerate"> -->
   <!-- </div> -->
    <!-- <div v-if="isContinue">
        <h3>It looks like you've tried this quiz before.</h3><p></p>
        <div class="row">
         <div class="col-sm-4"></div>
          <div class="col-sm-4">
              <b-button block squared @click="continueQuiz()" size="lg" variant="outline-success" >Continue Quiz</b-button><p></p>
              <b-button block squared @click="showQuiz()" variant="outline-dark" size="lg">Start Over</b-button>
 
          </div></div>
         <div class="col-sm-4"></div>

          


    </div> -->
    <!-- <div v-if="isFinished">              
        <h3>It looks like you've completed this quiz.</h3>
         <div class="row">
         <div class="col-sm-4"></div>
          <div class="col-sm-4">
              You got {{quizResults.correct}} out of {{quizResults.total}}  correct<p></p>
              <b-button block squared @click="showQuiz()" size="lg" variant="outline-dark" >Retake Quiz</b-button><p></p>
          </div>
         <div class="col-sm-4"></div>
         </div>
         </div> -->
   <!-- <div v-if="isQuiz">
   <h2>{{currentQuestion.question}}</h2> 
   <hr/>
    <div class="col-sm-4 container">

<div v-for="a in currentQuestion.choices" :key=a.id>

    <button class="btn btn-block btn-secondary" @click="submitAnswer(currentQuestion.id,a)" >{{a.text}}</button>
    <br/>
</div>
    </div>
    </div> -->

   <!-- <complete-question v-if="isQuiz" /> -->
   <!-- </div> -->
   <!-- <div id="checking" v-if="isChecking">
       <div class="spinner-grow text-dark" role="status">
  <span class="sr-only">Grading Question...</span>
</div>

   </div> -->
   <!-- <div v-if="isCompleted">Quiz Results are here <br/>
   <div v-if="quizResults">
    You got {{quizResults.correct}} right out of {{quizResults.total}} questions
    </div>
   </div> -->
   <!-- <div v-if="isNoQuiz">Oops, quiz not found.  No worries, try one of our other quizzes.</div> -->
  </div> 
</template>

<script>
import StartButton from '../common/StartButton'
import db from '../../../lib/db'
import Titles from '../common/Title'
import Generating from '../common/GeneratingLoad'
import FinishedQuiz from '../common/FinishedQuiz'
import QuizNotFound from '../common/QuizNotFound'
import ContinueQuiz from '../common/ContinueQuiz'
import QuizQuestion from '../common/QuizQuestion'
import QuizResults from '../common/QuizResults'
import QuizChoices from '../common/QuizChoices'
import CompleteQuestion from '@/components/common/CompleteQuestion'
export default {
  name: 'QuizPage',
  props: {
    msg: String
  },
  data() {
      return {
          showid: '',
          isBegin: false,
          isQuiz: false,
          isCompleted: false,
          isChecking: false,
          isGenerate: false,
          isNoQuiz: false,
          quizData: {},
          quizUser: {},
          sessArr: [],
          currentQuestion: {},
          currentSession: {count:0},
          quizResults: {},
          isFinished: false,
          isContinue: false
      }
  },
  computed: {
      fetchedTitle: function() {
          return this.quizData.title
      }
  },
  methods: {
    //   funCall: function(){
    //     db.callFunc('initSession')({quiz: this.$route.params.quizid}).then(function(result) {
    //        console.log(result)
    //     }).catch(function(error) {
    //         console.log('func error ', error)
    //     })
    //   },
      getQuiz: function (quizid) {
         return db.getRef().ref('quizquestions/'+quizid+'/details')
         .once('value').then((snapshot) => {
             if(snapshot.exists()){
              console.log('quiz retrieved ', snapshot.val())
              this.quizData = snapshot.val()
            //   this.isBegin = true
              return snapshot.val()
             }
             else {
                 console.log('nooooooo')
                 this.quizData.title = 'Not Found'
                 this.showNoQuiz();
                 return snapshot.val()
             }
          })
          .catch((error) => {
              console.log('error getting quiz ', error)
              return error
          })
      },
      showNoQuiz: function () {
          // do a call to get the latest quizzes, when this is setup
          this.clearViews();
          this.isNoQuiz = true
      },
      submitAnswer: function(question,answer){
          console.log('qqqqq ', question, 'lsdkfjld , ', answer)
        this.isQuiz = false
        this.isChecking = true
        this.checkAnswer(question,answer)
      },
    //   gradeAnswer: function(q,a) {
    //       console.log('user submitted answer ', a)
    //       const ansRef = db.getRef().ref('quizanswers/'+this.$route.params.quizid+'/'+q)
    //       return ansRef.once('value').then((snapshot)=> {
    //           if(snapshot.exists()) {
    //               if(snapshot.child('id').val() === a.id){
    //                   console.log('you guessed the right answer')
    //                   this.currentSession.correct++
    //               }
    //               else{
    //                   console.log('you got the question wrong')
    //               }
    //               console.log('correct answer is ', snapshot.child('text').val())
    //           }
    //       })
    //   },
    //   prevQuestion: function (qid){
    //       let cs = this.currentSession
    //       let sessionRef = db.getRef().ref('sessions/'+cs.user+'/'+cs.quiz
    //         +'/'+cs.sessid+'/qids/'+qid)
    //         return sessionRef.once('value').then((snapshot)=>{
    //             if(snapshot.exists()) {
    //                 console.log('got at least one question ',snapshot.numChildren())
    //                 return sessionRef.update({id: null})
    //             }
    //             else {
    //                 console.log('no more questions')
    //             }
    //         })
    //     //   return db.getRef().ref('sessions/'+cs.user+'/'+cs.quiz
    //     //     +'/'+cs.sessid+'/qids/'+qid).update({id: null})
    //   },
      continueQuiz: function () {
          if(this.currentSession.sessionid){
              console.log('we got a sessoin , ', this.currentSession)
              this.clearViews()
              this.isGenerate = true
              this.getQuestion(this.currentSession).then((quiz) => {
                  this.isGenerate = false
                  this.isQuiz = true
              })
              .catch((error) => {
                  console.log(error)
              })
          }
          else {
                console.log('restarrt quiz')
                this.isBegin = true
                this.getQuiz(this.$route.params.quizid)  
          }
        },
      nextQuestion: function(session){
        // let cs = this.currentSession
        let countRef = db.getRef().ref('sessions/'+session.user+'/'+session.quiz
            +'/'+session.sessionid+'/qcount')
            return countRef.once('value').then((snapshot) => {
        if(snapshot.child('count').val() < snapshot.child('total').val()){
        // this.getQid(cs).then((qid)=>{
        console.log('myq ', snapshot.val())
        this.getQuestion(session)
    // })
        } else{
            this.quizResults = snapshot.val()
            console.log('end quiz lkj ', snapshot.val())
            this.isQuiz = false
            this.isBegin = false
            this.isCompleted =true
        }
            })
      },
      clearViews: function () {
        this.isNoQuiz = false
        this.isQuiz = false
        this.isBegin = false
        this.isContinue = false
        this.isFinished = false
        this.isCompleted = false
      },
      showQuiz: function (stat) {
          console.log('start the mufthaf')
          this.clearViews()
          this.isGenerate = true
          this.remoteInit(this.$route.params.quizid).then(() => {
            // this.isGenerate = false
            this.isQuiz = true
          })
        //   this.initSession(this.quizUser,this.$route.params.quizid,this.quizData)
      },
    //   initQuiz: function () {
    //       this.paramId = this.$route.params.quizid
    //       console.log('get info form this quizid ', this.$route.params.quizid)
    //   },
        userLogin: function () {
       return db.anonAuth().then((user) => {
          console.log('anon credentia ', user.user.uid)
          this.quizUser = user.user.uid
          this.currentSession.user = user.user.uid
          return user.user
        }) 
      },
        getQuestion: function (session) {
            return this.getQid(session).then((qid) => { 
                console.log('what the quid ',qid)
            return db.getRef().ref('quizquestions/'+session.quiz+'/questions/'+
            qid).once('value').then((snapshot)=> {
                console.log('first question ', snapshot.val())
                this.currentQuestion = snapshot.val()
            })
            })
        },
        getQid: function (session) {
            return db.getRef().ref('sessions/'+session.user+'/'+session.quiz
            +'/'+session.sessionid+'/qids').limitToFirst(1)
            .once('child_added').then((snapshot)=> {
                if(snapshot.exists()){
                console.log('snappy vals ', snapshot.child('id'))
                return snapshot.key
                }
                else {
                    console.log('no more questions ')
                }
            })
        },
        makeToast(data) {
        this.$bvToast.toast(data.msg
        , {
          title: data.title,
          toaster: data.pos,
          variant: data.variant,
          autoHideDelay: 1750,
          noCloseButton: true,
          solid: true
        })
      },
        checkStatus: function (user,quiz){
            this.clearViews()
            return db.getRef().ref('sessions/'+user+'/'+quiz)
            .once('value').then((snapshot) =>{
                let sessKey = ''
                if(snapshot.exists() && snapshot.numChildren() === 1){
                    console.log('i have attempted this quiz ', snapshot.numChildren() )
                    snapshot.forEach((childsnap) => {
                        sessKey = childsnap.key
                        console.log('child snap s', sessKey)
                    })
                    //check if the quiz has been completed
                    if(snapshot.child(sessKey+'/qids').val()){
                        console.log('questions remain, continue quiz')
                        this.currentSession.sessionid = sessKey

                        this.isContinue = true;
                    }
                    else{
                        console.log('no questions, quiz completed, show score')
                        this.quizResults = snapshot.child(sessKey+'/qcount').val()
                        if(!this.$route.query.replay) {
                             this.isFinished = true
                        }
                    }
                }
                else {
                    console.log('i am new, start a new quiz ', snapshot.val())
                    if(!this.$route.query.replay) {
                        this.isBegin = true
                    }
                    this.getQuiz(this.$route.params.quizid)  
                }
            })
        },
        replayInit: function () {
            // this.isGenerate = true
            this.clearViews()
           return db.callFunc('sessionReplay')({quiz: this.$route.params.quizid}).then((result) => {
           console.log('session result ', result.data)
           console.log('replay got back ', result.data)
        //    this.nextQuestion(this.currentSession)
         this.getQuestion(result.data).then(() => {
               this.isContinue = false
               this.isQuiz = true
           })
           this.currentSession.sessionid = result.data.sessionid
            this.$router.push({ name: 'quiz', params: { quizid: result.data.quiz  } })
           })
           .catch((error) => {
               console.log('error initing replay /, ', error)
           }) 
        },
        remoteInit: function() {
            return db.callFunc('initSession')({quiz: this.$route.params.quizid}).then((result) => {
           console.log(result)
           this.getQuestion(result.data).then(() => {
               this.isGenerate = false

           })
           this.currentSession.sessionid = result.data.sessionid
        }).catch(function(error) {
            console.log('func error ', error)
        })
        },
        checkAnswer: function(question,answer) {
            let payload = {
                question: question,
                sessionid: this.currentSession.sessionid,
                answer: answer,
                quiz: this.$route.params.quizid
            }
            return db.callFunc('checkAnswer')(payload)
            .then((result) => {
                console.log('yyyy  ',result.data)
                this.makeToast(result.data)
               setTimeout(() => {
                this.currentQuestion = ""
                this.nextQuestion(this.currentSession)
                this.isChecking = false
                this.isQuiz = true }, 2000);

            })
            .catch((error) => {
                console.log('error ', error)
            })
        },
        // initSession: function (user,id,quiz){
        //     console.log('suer ', user)
        //     let sessRef = db.getRef().ref('sessions')
        //     let qNum = 0
        //     sessRef.child(user+'/'+id).push().then((ref)=>{
        //         console.log('new session id ', ref.key)
        //         console.log('quiz ids ', quiz)
        //         this.sessionArr(quiz.questionids)
        //          //store question keys under session node
        //     const keys = Object.entries(quiz.questionids)
        //     for (const key of keys) {
        //          sessRef.child(user+'/'+id+'/'+ref.key+'/qids/'+key[0])
        //          .set({id: key[0]})
        //         console.log('the key iey', key)
        //         qNum++
        //         }
        //          sessRef.child(user+'/'+id+'/'+ref.key+'/qcount')
        //          .update({total:qNum})
        //         return ref.key
        //     }).then((key)=>{
        //         let session = {sessid: key, user: user, quiz: id}
        //         this.currentSession = {sessid: key, user: user, quiz: id, correct: 0,count: 0, total:qNum}
        //         console.log('session id to start quiz ', key)
        //         //get the first qid
        //         this.getQid(session).then((qid)=>{
        //             console.log('myq ', qid)
        //             this.getQuestion(this.$route.params.quizid,qid)
        //         })
        //         // get the first question from the qid
                
        //     })
        // },
        // sessionArr: function (questions) {
        //     //store questions keys into an array
        //     let sessArr = []
        //     sessArr.push(questions)
        //     console.log(sessArr)
           
        // },
        initPage: function() {
            return this.userLogin().then((user) => {
                  console.log('query pa m ar', this.$route.query)    
                this.checkStatus(user.uid,this.$route.params.quizid)
                this.getQuiz(this.$route.params.quizid)  
                this.currentSession.quiz = this.$route.params.quizid
                 if(this.$route.query.replay){
                    const replayRef = db.getRef().ref('replay/'+user.uid+'/'+this.$route.params.quizid)
                    replayRef.once('value').then((snapshot) => {
                        if(snapshot.exists()) {
                            console.log('we got a valied replay')
                            this.replayInit()
                        }
                        else{
                            console.log('no replay found here')
                            this.$router.push({ name: 'quiz', params: { quizid: result.data.quiz  } })

                        }
                    })
                console.log('check for a replay id')
                
            }

            })
        }
  },
  components: {
      StartButton,
      Titles,
      QuizQuestion,
      QuizChoices,
      Generating,
      QuizResults,
      ContinueQuiz,
      FinishedQuiz,
      QuizNotFound,
      CompleteQuestion
  },
  created(){
    //   this.userLogin()
    //   this.currentSession.quiz = this.$route.params.quizid
    //   this.getQuiz(this.$route.params.quizid)
    // this.initQuiz()
        this.initPage()

  },
   watch: {
    $route(to, from) {
      // react to route changes...
      this.initPage()
      console.log('route chage quer')

    }
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
